'use client';

import { useEffect } from 'react';
import Link from 'next/link';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <html lang="en">
      <head>
        <title>Error | 100xprompt</title>
        <meta name="description" content="An error occurred while loading this page. Please try again or return to the homepage." />
      </head>
      <body>
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-black to-gray-900">
          <div className="text-center px-6 py-12 max-w-2xl">
            <div className="mb-8">
              <h1 className="text-6xl font-bold text-white mb-4">Oops!</h1>
              <h2 className="text-2xl font-semibold text-gray-300 mb-6">
                Something went wrong
              </h2>
              <p className="text-gray-400 mb-8">
                We encountered an unexpected error. Our team has been notified and we&apos;re working on fixing it.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={reset}
                className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors"
              >
                Try Again
              </button>
              <Link
                href="/"
                className="px-6 py-3 bg-gray-800 hover:bg-gray-700 text-white font-medium rounded-lg transition-colors inline-block"
              >
                Go Home
              </Link>
            </div>

            {error.digest && (
              <p className="mt-8 text-sm text-gray-500">
                Error ID: {error.digest}
              </p>
            )}
          </div>
        </div>
      </body>
    </html>
  );
}
